<template>
  <div class="form-step-5">
    <!-- Club Header -->
    <div class="form-step-5__header">
      <app-form-subtitle
        class="form-step-5__header__text"
        i18n-code="teamRegistrationSite.form.step1.title"
      />
      <i
        class="form-step-5__header__icon icon-pen"
        @click="goToStep(1)"
      />
    </div>

    <!-- Club Content -->
    <div class="form-step-5__content">
      <app-i18n
        tag="p"
        class="form-step-5__content__title"
        code="teamRegistrationSite.form.step5.subtitles.clubInformation"
      />
      <div class="form-step-5__content__section form-step-5__content__section--club">
        <div
          class="form-step-5__content__logo"
          :style="{ backgroundImage: `url('${model.clubLogo[0].publicUrl}')` }"
        />
        <div class="form-step-5__content__titles">
          <p
            class="form-step-5__content__title form-step-5__content__title--tertiary"
            v-text="clubLegalEntityId"
          />
          <p
            class="form-step-5__content__title form-step-5__content__title--primary"
            v-text="clubName"
          />
          <p
            class="form-step-5__content__title form-step-5__content__title--secondary"
            v-text="clubType"
          />
          <div class="form-step-5__content__wrapper">
            <p
              v-if="clubWebsite"
              class="form-step-5__content__text form-step-5__content__text--center"
            >
              <i class="form-step-5__content__icon icon-link" />
              <a
                class="form-step-5__content__link"
                target="_blank"
                :href="clubWebsite"
                v-text="clubWebsite"
              />
            </p>
            <p
              class="form-step-5__content__text form-step-5__content__text--center"
            >
              <i class="form-step-5__content__icon icon-file" />
              <span v-text="clubLegalName"></span>
            </p>
          </div>
        </div>
      </div>
      <div class="form-step-5__content__section">
        <app-i18n
          tag="p"
          class="form-step-5__content__title"
          code="teamRegistrationSite.form.step5.subtitles.clubAccommodation"
        />
        <app-i18n
          class="form-step-5__content__text"
          code="entities.teamRegistration.fields.clubNeedsAccommodation"
        />
        <span v-text="' '" />
        <span
          class="form-step-5__content__text form-step-5__content__text--highlight"
          v-text="model.clubNeedsAccommodation ? i18n('common.yes') : i18n('common.no')"
        />
      </div>
      <div class="form-step-5__content__section">
        <app-i18n
          tag="p"
          class="form-step-5__content__title"
          code="teamRegistrationSite.form.step5.subtitles.clubKitHome"
        />
        <div class="form-step-5__content__kit">
          <div class="form-step-5__content__kit__type">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__type__label"
              code="teamRegistrationSite.form.step5.subtitles.clubJerseyType"
            />
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__type__text"
              :code="`enumerators.clubKitPieceType.${model.clubKitHome.jersey.type}`"
            />
          </div>
          <div class="form-step-5__content__kit__piece">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__piece__text"
              code="teamRegistrationSite.form.step5.subtitles.clubJerseyColor"
            />
            <div
              class="form-step-5__content__kit__piece__color"
              :style="{ backgroundColor: colorNameToHex(model.clubKitHome.jersey.color1) }"
            />
            <div
              v-if="model.clubKitHome.jersey.color2"
              class="form-step-5__content__kit__piece__color"
              :style="{ backgroundColor: colorNameToHex(model.clubKitHome.jersey.color2) }"
            />
          </div>
          <div class="form-step-5__content__kit__piece">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__piece__text"
              code="teamRegistrationSite.form.step5.subtitles.clubPantsColor"
            />
            <div
              class="form-step-5__content__kit__piece__color"
              :style="{ backgroundColor: colorNameToHex(model.clubKitHome.pants.color1) }"
            />
          </div>
        </div>
      </div>
      <div
        v-if="model.clubKitAway.jersey.color1 && model.clubKitAway.pants.color1"
        class="form-step-5__content__section"
      >
        <app-i18n
          tag="p"
          class="form-step-5__content__title"
          code="teamRegistrationSite.form.step5.subtitles.clubKitAway"
        />
        <div class="form-step-5__content__kit">
          <div class="form-step-5__content__kit__type">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__type__label"
              code="teamRegistrationSite.form.step5.subtitles.clubJerseyType"
            />
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__type__text"
              :code="`enumerators.clubKitPieceType.${model.clubKitAway.jersey.type}`"
            />
          </div>
          <div class="form-step-5__content__kit__piece">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__piece__text"
              code="teamRegistrationSite.form.step5.subtitles.clubJerseyColor"
            />
            <div
              class="form-step-5__content__kit__piece__color"
              :style="{ backgroundColor: colorNameToHex(model.clubKitAway.jersey.color1) }"
            />
            <div
              class="form-step-5__content__kit__piece__color"
              v-if="model.clubKitAway.jersey.color2"
              :style="{ backgroundColor: colorNameToHex(model.clubKitAway.jersey.color2) }"
            />
          </div>
          <div class="form-step-5__content__kit__piece">
            <app-i18n
              class="form-step-5__content__text form-step-5__content__kit__piece__text"
              code="teamRegistrationSite.form.step5.subtitles.clubPantsColor"
            />
            <div
              class="form-step-5__content__kit__piece__color"
              :style="{ backgroundColor: colorNameToHex(model.clubKitAway.pants.color1) }"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Address Header -->
    <div class="form-step-5__header">
      <app-form-subtitle
        class="form-step-5__header__text"
        i18n-code="teamRegistrationSite.form.step2.title"
      />
      <i
        class="form-step-5__header__icon icon-pen"
        @click="goToStep(2)"
      />
    </div>

    <!-- Address Content -->
    <div class="form-step-5__content">
      <div class="form-step-5__content__section form-step-5__content__section--address">
        <i class="form-step-5__content__icon icon-location" />
        <p
          class="form-step-5__content__text"
          v-text="clubAddress"
        />
      </div>
    </div>

    <!-- Persons Header -->
    <div class="form-step-5__header">
      <app-form-subtitle
        class="form-step-5__header__text"
        i18n-code="teamRegistrationSite.form.step3.title"
      />
      <i
        class="form-step-5__header__icon icon-pen"
        @click="goToStep(3)"
      />
    </div>

    <!-- Persons Content -->
    <div class="form-step-5__content form-step-5__content--persons">
      <div
        class="form-step-5__content__section"
        v-for="(person, i) in model.clubContactPersons"
        :key="`club-contact-person--${i}`"
      >
        <p
          class="form-step-5__content__title form-step-5__content__title--tertiary"
          v-text="person.position"
        />
        <p
          class="form-step-5__content__text form-step-5__content__text--highlight"
          v-text="`${person.firstName} ${person.lastName}`"
        />
        <p class="form-step-5__content__text">
          <i class="form-step-5__content__icon icon-mail" />
          <span v-text="person.email" />
        </p>
        <p class="form-step-5__content__text">
          <i class="form-step-5__content__icon icon-phone" />
          <span v-text="`${person.phone.prefix} ${person.phone.number}`" />
        </p>
      </div>
    </div>

    <!-- Teams Header -->
    <div class="form-step-5__header">
      <app-form-subtitle
        class="form-step-5__header__text"
        i18n-code="teamRegistrationSite.form.step4.titleAlt"
      />
      <i
        class="form-step-5__header__icon icon-pen"
        @click="goToStep(4)"
      />
    </div>

    <!-- Teams Content -->
    <div class="form-step-5__content">
      <div class="form-step-5__content__section form-step-5__content__section--categories">
        <div
          class="form-step-5__content__section__column"
          v-for="gender in clubCategoriesAvailableGenders"
          :key="`club-categories--${gender}`"
        >
          <p
            class="form-step-5__content__text form-step-5__content__text--category"
            v-for="(category, i) in clubCategories[gender]"
            :key="`club-categories--${gender}--${i}`"
          >
            <span>
              <template v-if="category.showGenderLabel">
                <i class="form-step-5__content__icon icon-player" />
                <app-i18n :code="`teamRegistrationSite.form.step5.categoryGender.${category.gender}`" />
              </template>
            </span>
            <span>
              <app-i18n :code="`enumerators.soccerFormat.${category.format}`" />
              <span v-text="` · `" />
              <span v-text="ageCategories.find(c => c.id === category.ageCategory).label" />
              <span v-if="category.teams" v-text="` ${category.teams.join(', ')}`" />
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import colorMixin from '@/mixins/color'

import { i18n } from '@shared/i18n';
import AppFormSubtitle from '@/components/FormSubtitle.vue'

export default {
  name: 'appFormStep5',
  data() {
    return {
      i18n,
    }
  },
  mixins: [colorMixin],
  computed: {
    ...mapGetters('teamRegistration', ['model']),
    ...mapState('tournament', ['ageCategories']),
    clubLegalEntityId() {
      const label = i18n('entities.teamRegistration.fields.clubLegalEntityId')
      const { clubLegalEntityId } = this.model
      return `${label}: ${clubLegalEntityId}`
    },
    clubName() {
      return this.model.clubName
    },
    clubLegalName() {
      return this.model.clubLegalName
    },
    clubType() {
      const { clubType, clubFederation } = this.model
      const typeLabel = i18n(`enumerators.clubType[${clubType}]`)
      
      if (clubType !== 'federated') return typeLabel

      const federationLabel = i18n(`enumerators.clubFederation[${clubFederation}]`)
      return `${typeLabel} (${federationLabel})`
    },
    clubWebsite() {
      const { clubWebsite: url } = this.model
      if (!url) return null
      return url.startsWith('http') ? url : `https://${url}`
    },
    clubAddress() {
      const { line1, line2, postalCode, city, state, country } = this.model.clubAddress
      const lines = line2 ? `${line1}, ${line2}` : line1
      const countryLabel = i18n(`enumerators.country.${country}`)
      const stateLabel = i18n(`enumerators.stateProvince.${country}.${state}`)
      return `${lines}, ${postalCode} ${city} (${stateLabel}) - ${countryLabel.toUpperCase()}`
    },
    clubCategories() {
      let maleGenderLabelAssigned = false
      let femaleGenderLabelAssigned = false

      const clubCategories = [...this.model.clubCategories]

      return clubCategories.sort((a, b) => {
        if (a.gender > b.gender) return 1
        if (a.gender === b.gender) {
          if (a.format < b.format) return 1
          if (a.format === b.format) {
            if (a.ageCategory > b.ageCategory) return 1
            return -1
          }
          return -1
        }
        return -1
      }).map(c => {
        if (c.gender === 'male' && maleGenderLabelAssigned) return c
        if (c.gender === 'female' && femaleGenderLabelAssigned) return c

        if (c.gender === 'male') maleGenderLabelAssigned = true
        if (c.gender === 'female') femaleGenderLabelAssigned = true

        return {
          ...c,
          showGenderLabel: true,
        }
      }).reduce((result, category) => {
        const { gender } = category
        if (!result[gender]) result[gender] = []
        result[gender].push(category)
        return result
      }, {
        male: [],
        female: [],
      })
    },
    clubCategoriesAvailableGenders() {
      return ['male', 'female'].filter(g => !!this.clubCategories[g].length)
    },
  },
  methods: {
    ...mapActions('form', ['goToStep']),
  },
  components: {
    AppFormSubtitle,
  },
}
</script>

<style lang="scss" scoped>
.form-step-5 {
  text-align: left;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background-color: #f5f5f5;

    &__text {
      margin: 0;
    }

    &__icon {
      cursor: pointer;
    }
  }

  &__content {
    margin-bottom: 16px;
    padding: 24px 16px;

    &:last-of-type {
      margin-bottom: 0;
      padding-bottom: 0;
    }

    &--persons {
      @include tablet {
        display: flex;
      }

      .form-step-5__content__section {
        margin-bottom: 24px;

        @include tablet {
          flex-grow: 1;
        }

        .form-step-5__content__title--tertiary {
          margin-bottom: 4px;
          font-size: 14px;
        }

        .form-step-5__content__text {
          margin-top: 2px;
        }

        .form-step-5__content__icon {
          margin-right: 8px;
        }
      }
    }

    &__section {
      margin-bottom: 40px;

      &:last-of-type {
        margin-bottom: 0;
      }

      &__column {
        margin-bottom: 24px;

        @include tablet {
          width: 50%;
          margin-bottom: 0;

          &:nth-child(even) {
            padding: 0 0 0 8px;
          }

          &:nth-child(odd) {
            padding: 0 8px 0 0;
          }
        }
      }

      &--club {
        align-items: center;
        text-align: center;

        @include tablet {
          display: flex;
          text-align: left;
        }
      }

      &--categories {
        @include tablet {
          display: flex;
        }
      }

      &--address {
        display: flex;

        i {
          margin: 2px 8px 0 0;
        }
      }
    }

    &__logo {
      width: 104px;
      height: 104px;
      margin: 16px auto;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      border: 1px solid #ebebeb;
      border-radius: 100%;

      @include tablet {
        margin: 16px 0;
      }
    }

    &__titles {
      @include tablet {
        margin-left: 24px;
        text-align: left;
      }

      .form-step-5__content__title {
        @include tablet {
          margin-bottom: 4px;
          text-align: left;
        }
      }
    }

    &__wrapper {
      @include tablet {
        display: flex;

        .form-step-5__content__text:first-child {
          margin-right: 20px;
        }
      }
    }

    &__title {
      margin-bottom: 8px;
      color: #565656;
      font-weight: normal;
      font-size: 16px;
      text-transform: uppercase;

      &--primary {
        color: #494949;
        font-weight: bold;
        font-size: 20px;
      }

      &--secondary {
        color: #494949;
        font-weight: normal;
        font-size: 20px;
      }

      &--tertiary {
        color: #c5c5c5;
        font-weight: normal;
        font-size: 12px;
        text-transform: none;
      }
    }

    &__text {
      color: #404040;
      font-weight: normal;
      font-size: 14px;

      &--link {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        @include tablet {
          text-align: center;
        }
      }

      &--highlight {
        font-weight: bold;
        font-size: 16px;
      }

      &--category {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        font-weight: normal;
        font-size: 12px;
        text-align: left;

        &:last-of-type {
          margin-bottom: 0;
        }

        .form-step-5__content__icon {
          margin-right: 8px;
        }

        & > span {
          display: inline-block;
          width: 65%;
          overflow: hidden;
          font-size: 12px;
          white-space: nowrap;
          text-overflow: ellipsis;

          &:first-of-type {
            width: 35%;
            font-size: 12px;

            @include mobile {
              font-size: 12px;
            }
          }
        }
      }
    }

    &__link {
      color: #2acccc;
      font-weight: normal;
      font-size: 14px;
    }

    &__icon {
      margin-right: 6px;
      font-size: 12px;
    }

    &__kit {
      @include tablet {
        display: flex;
        flex-wrap: wrap;
      }

      &__type {
        margin-top: 16px;

        @include tablet {
          flex-basis: 100%;
          margin-top: 8px;
        }

        &__label {
          @include tablet {
            display: inline-block;
            width: 25%;
            margin-right: 8px;
          }
        }

        &__text {
          font-weight: bold;
          font-size: 14px;
        }
      }

      &__piece {
        display: flex;
        align-items: center;
        margin: 16px 0;

        @include tablet {
          flex-grow: 1;
        }

        &__text {
          width: 50%;
        }

        &__color {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-left: 8px;
          border: 2px solid #f5f5f5;
          border-radius: 100%;
        }
      }
    }
  }
}
</style>
